import {observer} from "mobx-react"
import {InfoBubbleTooltipTrigerBox} from "./boxes/info-bubble-tooltip-triger.box"
import {useServices} from "../../react-hooks/use-services.hook"
import {top} from "@popperjs/core";
import {ReactElement, useRef} from "react";
import {InfoBubbleTooltipContentBox} from "./boxes/info-bubble-tooltip-content.box";
import {InfoBubbleTooltipTriggerWrapperBox} from "./boxes/info-bubble-tooltip-trigger-wrapper.box";
import {IRegularTooltipOptions} from "../../services/tooltip/regular-tooltip/regular-tooltip-options.interface";

interface InfoBubbleTooltipComponentProps extends Pick<IRegularTooltipOptions, 'placement' | 'styling'> {
    infoBubbleContent: string;
    fetureName: string;
    analyticsFeatureName: string;
    label?: string | ReactElement;
};


export const InfoBubbleTooltipComponent: React.FC<InfoBubbleTooltipComponentProps> = observer((props) => {
    const services = useServices();
    const infoBubbleTooltipTriggerRef = useRef();


    const showBubbleTooltip = () => {
        services.regularTooltips.showBubbleTooltip({
            renderContent: () => <InfoBubbleTooltipContentBox>{props.infoBubbleContent}</InfoBubbleTooltipContentBox>,
            placement: props?.placement || top,
            attachTo: infoBubbleTooltipTriggerRef?.current,
            styling: props?.styling,
            onTooltipRendered: () => {
                services.analytics.sendOrbitUserFlowEvent('InfoBubble', 'ClickToPresent', props.analyticsFeatureName)
            }
        });
    };


    return (
        <InfoBubbleTooltipTriggerWrapperBox>
            {props.label}
            <InfoBubbleTooltipTrigerBox
                src={services.theme.currentTheme.assets.images.letter_info_bubble_svg.toString()}
                onClick={showBubbleTooltip}
                ref={infoBubbleTooltipTriggerRef}
            />
        </InfoBubbleTooltipTriggerWrapperBox>
    );
});